import Axios from 'axios'
import { API_URL_HR_GLOSSARY_LIST } from 'src/@legacy/@core/utilities/APIConstant'
import withAppProvider from 'src/@legacy/layout/hoc/withAppProvider'
import withHeaderDynamic from 'src/@legacy/layout/hoc/withHeaderDynamic'
import HRGlossaryDetailPage from 'src/@legacy/wrapper/hr-glossary-detail'
// import { multipleLocale } from 'src/utilities/pageUtilities'
// import { fetchGlossaryList } from '../index'

const fetchJobDetail = (filter: string) => Axios.get(`${API_URL_HR_GLOSSARY_LIST}${filter}`, {}).then((rs) => rs.data.data[0])

// export async function getStaticPaths() {
//   const glossaryList = await fetchGlossaryList()

//   // Get the paths we want to pre-render based on posts
//   const paths = multipleLocale(glossaryList, (glossary, locale) => {
//     return locale === 'eng' ? glossary.slug : glossary.slug_vi
//   })

//   return {
//     paths,
//     fallback: 'blocking' // can also be true or 'blocking'
//   }
// }

export async function getServerSideProps({ params }) {
  const { slug } = params

  const filter = `?filter={"_or":[{"slug_vi":%20"${slug}"},%20{"slug":%20"${slug}"%20}]}`

  // Fetch data from external API
  const data = await fetchJobDetail(filter)

  // Pass data to the page via props
  return { props: { glossaryDetail: data } }
}

export default withAppProvider(withHeaderDynamic(HRGlossaryDetailPage), { loadOnClient: false })
